import { FilteredProducts } from "../../components/FilteredProducts"

export const EventsView = () => {
  return (
    <>
      <FilteredProducts input={{ variant: "events" }} />
    </>
  )
}
